import React from 'react'

import { Form } from '../containers'

function App() {
  return <Form />
}

export default App



// WEBPACK FOOTER //
// ./src/components/App.js